import { render, staticRenderFns } from "./exception-type.vue?vue&type=template&id=02632b18"
import script from "./exception-type.vue?vue&type=script&lang=js"
export * from "./exception-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports